import {Dispatch} from 'redux';

import Types from '../Types';

import CharacterPatternMapping from '../../view_models/CharacterPatternMapping';

import SceneCommandForm from '../../../domain/forms/scene_commands/SceneCommandForm';

export interface Params {
  sceneCommandForm: SceneCommandForm;
  characterPatternMapping?: CharacterPatternMapping;
}

export default function action(params: Params) {
  return (dispatch: Dispatch<any>) => {
    const payload = params;
    dispatch({
      payload,
      type: Types.UpdateSceneCommandForm,
    });
    return new Promise(resolve => resolve(payload));
  };
}
